module.exports = __webpack_public_path__ + "static/media/7.3ba0f0bc.jpeg";